import { Icon } from "@/components/ui/icon";
import { Tabs, useNavigation, useRouter } from "expo-router";
import { LucideIcon, Icon as IconL } from "lucide-react-native";
import { usePalette } from "@/utils/usePalette";
import { PropsWithChildren } from "react";
import { useMobileBreakpoint } from "@/utils/useMobileBreakpoint";
import { TabLayout, useTabLayoutContext } from "../dashboard/tab.layout";
import { Platform } from "react-native";
import { Pressable } from "@/components/ui/pressable";
import { BottomTabBarButtonProps } from "@react-navigation/bottom-tabs";
import {
  useRoute,
} from "@react-navigation/native";

export const makeMobileIconTabBar =
  (icon: LucideIcon | typeof IconL) =>
  (props: { focused: boolean; color: string; size: number }) =>
    <MobileIconTabBar {...{ icon, ...props }} />;

export function MobileIconTabBar(props: {
  icon: LucideIcon | typeof IconL;
  focused: boolean;
  color: string;
  size: number;
}) {
  const breakpoint = useMobileBreakpoint();

  return (
    <Icon
      as={props.icon}
      size={breakpoint ? Math.max(props.size, 20) : props.size}
      className={props.focused ? "text-typography-900" : "text-typography-400"}
    />
  );
}

export function MobileTabBarButton(props: BottomTabBarButtonProps) {
  const routeCtx = useRoute();
  const { state, navigation } = useTabLayoutContext();
  const test = useRouter();
  const test2 = useNavigation();

  return (
    <Pressable
      {...props}
      onPress={(e) => {
        e.preventDefault();

        const index = state.routes.findIndex((r) => r.key === routeCtx.key);

        if (index === state.index) {
          const state = navigation.getState();
          test.dismissTo(`/${state.routeNames[index]}` as any);
        } else {
          props.onPress?.(e);
        }
      }}
    />
  );
}

export function MobileTabs(props: PropsWithChildren) {
  const breakpoint = useMobileBreakpoint();
  const palette = usePalette();

  return (
    <Tabs
      layout={TabLayout}
      screenOptions={{
        popToTopOnBlur: breakpoint === "desktop",
        headerShown: false,
        tabBarStyle: {
          display: breakpoint == "mobile" ? "flex" : "none",
          backgroundColor: palette["--color-background-0"],
        },
        tabBarActiveTintColor: palette["--color-typography-900"],
        tabBarInactiveTintColor: palette["--color-typography-400"],
        tabBarLabelStyle: {
          fontSize: 14,
          fontFamily: "Roboto, sans-serif",
          overflow: "visible",
          ...(Platform.OS === "web" ? { marginTop: -2 } : undefined),
        },
        tabBarButton: (props) => <MobileTabBarButton {...props} />,
      }}
    >
      {props.children}
    </Tabs>
  );
}
